import { useSelector } from "react-redux";

const PosLoader = () => {
  const logo = useSelector((state) => state.broker?.logo);

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-6 bg-black/20">
      {logo && (
        <img
          src={logo}
          alt="Logo"
          className="h-14 object-contain animate-pulse"
        />
      )}

      <div className="flex items-center gap-2">
        <span className="h-4 w-4 rounded-full bg-black animate-bounce [animation-delay:-0.3s]" />
        <span className="h-4 w-4 rounded-full bg-black animate-bounce [animation-delay:-0.15s]" />
        <span className="h-4 w-4 rounded-full bg-black animate-bounce" />
      </div>

      <p className="text-xs font-semibold tracking-wide text-black">
        Loading, please wait...
      </p>
    </div>
  );
};

export default PosLoader;
